var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiScales3Fill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3106_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3331 3.16406V4.86806L23.9998 7.09206L28.8424 5.47873L29.6864 8.00673L25.6438 9.35473L29.7718 20.7041C28.3158 22.2201 26.2664 23.1641 23.9998 23.1641C21.7318 23.1641 19.6838 22.2201 18.2278 20.7041L22.3531 9.35473L17.3331 7.68006V25.8307H22.6664V28.4974H9.33312V25.8307H14.6664V7.68006L9.64245 9.35473L13.7704 20.7041C12.3158 22.2201 10.2664 23.1641 7.99978 23.1641C5.73178 23.1641 3.68378 22.2201 2.22778 20.7041L6.35312 9.35473L2.31312 8.00806L3.15712 5.4774L7.99978 7.09073L14.6664 4.86806V3.16406H17.3331ZM23.9998 12.6347L22.1091 17.8307H25.8891L23.9998 12.6347ZM7.99978 12.6347L6.10912 17.8307H9.88912L7.99978 12.6347Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3106_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiScales3Fill);
export default __webpack_public_path__ + "static/media/ri-scales-3-fill.ad37e40c410515fe2d96fd7c3cb13474.svg";
export { ForwardRef as ReactComponent };